export default __webpack_public_path__ + "static/media/wall.43f8ece7.PNG";